var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-bottom":"30px","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"}},[_c('el-card',{staticStyle:{"width":"600px","margin-top":"30px"}},[_c('h3',[_vm._v("请从 store-server 命令的输出获取管理后台地址")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }